import { padding } from '@libs/theme/mixins'
import { Menu } from 'antd'
import styled from 'styled-components'

const LinkItem = styled(Menu.Item)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${padding('xxs')};
`

export default {
	LinkItem,
}
